// removed by extract-text-webpack-plugin
module.exports = {"banners":"_31fwC","banner":"_3H2J0","enter":"_3lli-","enterActive":"_1p9aM","leave":"_2Yx82","leaveActive":"E8KpZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Banners.css
// module id = 796
// module chunks = 0